import PlatformDocumentMetadata from "@/features/PlatformDocuments/PlatformDocumentMetadata";
import TemporaryPlatformDocument from "@/features/PlatformDocuments/TemporaryPlatformDocument";

export default class UploadedPlatformDocumentMetadata {
    uploadedPlatformDocument: TemporaryPlatformDocument = new TemporaryPlatformDocument();
    uploadedPlatformDocumentMetaData: PlatformDocumentMetadata = new PlatformDocumentMetadata();
}
